import { context } from '@wikia/ad-engine';

export function getWikiaContext(): object {
	const floorAdhesionConfigs = context.get('experiments.persistentAdhesionExperiment')
		? {
				adhesion_limited: {
					sizes: [[320, 50]],
				},
			}
		: {
				floor_adhesion: {
					sizes: [[320, 50]],
				},
			};

	return {
		enabled: false,
		slots: {
			mobile_top_leaderboard: {
				sizes: [[320, 50]],
			},
			mobile_in_content: {
				sizes: [[300, 250]],
			},
			bottom_leaderboard: {
				sizes: [[300, 250]],
			},
			...floorAdhesionConfigs,
			interstitial: {
				sizes: [[320, 480]],
			},
			gallery_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.gallery_leaderboard ?? [
					[320, 50],
					[320, 100],
				],
			},
		},
	};
}
